import axios from 'axios'

export const confirmReservation = (id) =>
  axios({
    method: 'post',
    url: `/api/reservation/${id}/confirm`,
  })
